import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
    FeatureLayout,
    FundsAvailableCard,
    ApprovalAccordion,
    HowItWorksAccordion,
    Status,
} from '@lendica/components';

import { useApprovalSummaryV2 } from './useApprovals';
import { useContainerWidth } from '@lendica/hooks';

export const MyApprovalsView = ({ onError }: { onError: () => void }) => {
    const { isNarrow } = useContainerWidth();
    const { data, loading, error } = useApprovalSummaryV2();

    return (
        <FeatureLayout loading={loading}>
            {!loading && data && data.length > 0 ? (
                <Box
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        sx={{
                            px: isNarrow ? 1 : 4,
                            pt: 2,
                            pb: isNarrow ? 2 : 4,
                            flexGrow: 1,
                            overflowY: 'auto',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="subtitle1" sx={{ mb: 2 }} textAlign="center">
                            Approvals
                        </Typography>
                        <Box mb={3}>
                            <FundsAvailableCard approvals={data} />
                        </Box>

                        {data.map(approval => (
                            <Box mb={3} key={approval.id}>
                                <ApprovalAccordion approval={approval} />
                            </Box>
                        ))}
                        <HowItWorksAccordion approvals={data} />
                    </Box>
                </Box>
            ) : (
                <Status title="Can't retrieve your approvals right now :(" onClick={onError} />
            )}
        </FeatureLayout>
    );
};
